// jquery-global.js
import jquery from "jquery";
(window as any).jQuery = jquery;
(window as any).$ = jquery;
